var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{attrs:{"app":""}},[_c('Logo'),_c('v-spacer'),(!_vm.auth.check())?_c('v-btn',{staticClass:"mx-2",attrs:{"color":"primary","text":"","to":{ name: 'Login' }}},[_vm._v(" Login ")]):_c('profileHeader',{})],1),_c('v-main',{staticClass:"background"},[_c('router-view')],1),_c('loader'),_c('app-footer'),_c('app-alert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }